import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { Redirect } from 'react-router-dom';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EventIcon from '@material-ui/icons/Event';
import Typography from '@material-ui/core/Typography';
import { IGetNewEvent } from '../../../interfaces/IGetNewEvent';
import NewsAndEventsCard from '../NewsAndEventsCard';
import { IRegisterEvent } from '../../../interfaces/IRegisterEvent';
import ResponsiveBasicModal from '../../ResponsiveBasicModal';
import ResourceForm from '../../ResourceForm';

interface InstructionListProps {
    data: Array<IGetNewEvent>;
    population: string;
}

const InstructionsList: React.FC<InstructionListProps> = ({ data, population }) => {
    const [url, setUrl] = useState<string | null>(null);
    const [dataAjusted, detDataAdjusted] = useState<Array<IRegisterEvent>>([]);
    const [openModal, setOpenModal] = React.useState(false);
    const [resourceSelected, setResourceSelected] = useState<number>(0);


    const handleSeeEvent = (idEvent: number) => {
        setOpenModal(false);
        setUrl(`/instructivos/${population}/${resourceSelected <= 0 ? idEvent : resourceSelected}`);
    }

    useEffect(() => {
        const newdata: Array<IRegisterEvent> = data.map(obj => new IRegisterEvent(obj));
        detDataAdjusted(newdata);
    }, [data])


    const handleOpen = (e: any, idEvent: number) => {
        setResourceSelected(idEvent);
        if (population === 'Empresas') {
            handleSeeEvent(idEvent);
        } else {
            setOpenModal(true);
        }
    };


    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <>
            {
                url !== null ?
                    <Redirect to={url} />
                    :
                    <>
                        {
                            dataAjusted.length > 0 &&
                            dataAjusted.map((event: IRegisterEvent) => (
                                <NewsAndEventsCard
                                    key={event.id}
                                    borderColor="#D7D7D7"
                                    bgColor="#F9F9F9"
                                    marginDef="10px 0"
                                    icon={<LocationOnIcon />}
                                    secondIcon={<EventIcon />}
                                    type={event.type}
                                    highlight={event.highlight}
                                    image={event.image}
                                    name={event.name}
                                    shortDescription={event.shortDescription}
                                    publishDate={event.publishDate}
                                    place={event.place}
                                    state={event.state}
                                >
                                    <Button variant="contained" className="content-btn" onClick={(e) => handleOpen(e, event.id)}>
                                        <Typography variant="h5" className="regular-serif">
                                            Ver <span className="btn-type-text">{event.type}</span>
                                        </Typography>
                                    </Button>
                                </NewsAndEventsCard>
                            ))
                        }
                        <ResponsiveBasicModal
                            fullWidth={false}
                            open={openModal}
                            handleClose={handleClose}
                            maxWidth='md'
                            children={
                                <ResourceForm
                                    backActionOverride={handleClose}
                                    afterUpdateAction={handleSeeEvent}
                                    idResource={resourceSelected}
                                ></ResourceForm>
                            }
                        />
                    </>
            }
        </>
    )
}

export default InstructionsList